export default {
  title: 'Dashboard',
  rechargeRankingDay: 'Recharge ranking of the day',
  rechargeAmount: 'Recharge amount',
  usersNumber: 'Number of users',
  orderNumber: 'Number of order',
  gameNumber: 'Number of games',
  gameID: 'game ID',
  effectiveRechargeRatio: 'Effective recharge ratio',
  cooperativeCompany: 'Cooperative company',
  fullServerRecharge: 'Full server recharge',
};
